<div class="container">
  <div class="container text-center">
    <div class="alert alert-success menssagem">

      Logout realizado com sucesso!

    </div>
  </div>
</div>
